import React, { FC, useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  errorModalViewStore,
  loadingModalViewStore,
  confirmModalViewStore,
  contentModalDep2ViewStore,
} from 'src/store/modal';
import { pensionDataStore } from 'src/store/pension';
import { fetchDeletePension, pensionInfoDataFn } from 'src/fetch/stepC/pension';
import { familyDataStore } from 'src/store/familyInfo';
import { getMemberInfo } from 'src/utils/common';
import TaxTopButton from 'src/components/organisms/template/StepC/template/TaxModal/TaxTopButton';
import TaxBottomDesc from 'src/components/organisms/template/StepC/template/TaxModal/TaxBottomDesc';
import GridList from './list';
import AddGrid from './upsert';
import '../tableRef.scss';
import './style.scss';

interface Props {
  type: string;
}
const CreditGrid: FC<Props> = ({ type }) => {
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const setConfirmModalState = confirmModalViewStore((state: any) => state.set);
  const closeModalState = confirmModalViewStore((state: any) => state.close);
  const setContentModalState = contentModalDep2ViewStore((state: any) => state.set);

  // 연금계좌
  const pensionDataState = pensionDataStore((state: any) => state.bind);
  const bindStoreParam = pensionDataStore((state: any) => state.param);
  const bindStoreBindParam = pensionDataStore((state: any) => state.bindParam);

  const familyInfoDataState = familyDataStore((state: any) => state.bind);
  const userInfoData: any = getMemberInfo();

  let viewData: any = [];
  const data = pensionDataStore((state: any) => state.result).data || [];
  viewData = data;

  // 연금계좌
  useEffect(() => {
    const param = userInfoData;
    pensionInfoDataFn(errorModalState, param, pensionDataState, queryClient, familyInfoDataState);
  }, [bindStoreParam]);

  //:State
  const [viewTypeState, setViewTypeState] = useState({ type: '' });

  const viewName = '연금계좌';

  const addClickEvent = () => {
    const payload = {
      active: '_active',
      title: viewName + ' 내역 추가',
      content: (
        <div className="_creditcard_layout">
          <div className="_add_list_grid">
            <div className="_add_div">
              <AddGrid data={viewData} type="insert" />
            </div>
          </div>
        </div>
      ),
      styleDef: { width: '1024px' },
    };
    setContentModalState(payload);
  };
  const modifyClickEvent = () => {
    viewTypeState.type === ''
      ? setViewTypeState({ type: 'modify' })
      : setViewTypeState({ type: '' });
  };

  const modifyItemEvent = (item: any) => {
    const payload = {
      active: '_active',
      title: viewName + ' 내역 수정',
      content: (
        <div className="_creditcard_layout">
          <div className="_add_list_grid">
            <div className="_add_div">
              <AddGrid data={item} type="update" />
            </div>
          </div>
        </div>
      ),
      styleDef: { width: '1024px' },
    };
    setContentModalState(payload);
  };
  const deleteItemEvent = (selItem: any) => {
    const confirmDiv = () => {
      return (
        <div className="_confirm_modal_content">
          <div className="_title">해당 내용을 삭제합니다.</div>
          <div className="_desc">내용을 삭제 하시겠습니까?</div>
        </div>
      );
    };
    setConfirmModalState({
      active: '_active',
      content: confirmDiv(),
      cancleEvt: (item: any) => {
        closeModalState({ content: null, active: '' });
      },
      confirmEvt: (item: any) => {
        const param = {
          acct_year: selItem?.acct_year,
          co_cd: selItem?.co_cd,
          co_id: selItem?.co_id,
          in_data_seqid: selItem?.in_data_seqid,
        };
        // return false;

        fetchDeletePension(param, queryClient, errorModalState, loadingState, () => {
          const initialSeq = bindStoreParam.initialSeq || 0;
          bindStoreBindParam({ initialSeq: initialSeq + 1 });
          setContentModalState({
            active: '',
          });
        });

        //Close
        closeModalState({ content: null, active: '' });
      },
    });
  };

  const listGrid = () => {
    return (
      <div className="_list_grid">
        <TaxTopButton
          addClickEvt={addClickEvent}
          modifyClickEvt={modifyClickEvent}
          viewType={viewTypeState.type}
        />
        <GridList
          data={viewData}
          viewType={viewTypeState.type}
          modifyItemEvt={modifyItemEvent}
          deleteItemEvt={deleteItemEvent}
        />
        <TaxBottomDesc />
      </div>
    );
  };

  return <div className="_creditcard_layout">{listGrid()}</div>;
};

export default CreditGrid;
